import { Input, OnDestroy, OnInit } from '@angular/core';
import {
  VertexInteractionPoint,
  VertexInteractionPointLocation,
  VertexInteractionPointSpecification,
  WorkflowVertex
} from 'component.workflow.core';
import { WorkflowGraphDispatcherService } from '../../workflow-graph-dispatcher.service';
import { AbstractWorkflowGraphDispatcherObserver } from '../../abstract-workflow-graph-dispatcher-observer';
import { WorkflowGraphService } from '../../workflow-graph.service';

export abstract class WorkflowGraphVertexInteractionPoint extends AbstractWorkflowGraphDispatcherObserver implements OnInit, OnDestroy {
  @Input() point: VertexInteractionPoint;
  @Input() specification: VertexInteractionPointSpecification;
  @Input() editable: boolean;

  @Input() vertex: WorkflowVertex;

  readonly radius = 8;

  constructor(dispatcherService: WorkflowGraphDispatcherService, protected graphService: WorkflowGraphService) {
    super(dispatcherService);
  }

  get initialized(): boolean {
    return !!this.specification;
  }

  get name(): string {
    return this.point.named ? this.point.name : '✸';
  }

  get typeText(): string {
    return this.point.dataType.toString();
  }

  get textX(): number {
    return this.specification.at.x + (
      this.specification.location & VertexInteractionPointLocation.Left ? -15 :
        this.specification.location & VertexInteractionPointLocation.Right ? 15 : 0);
  }

  get textY(): number {
    return this.specification.at.y + (
      this.specification.location & VertexInteractionPointLocation.Top ? -20 :
        this.specification.location & VertexInteractionPointLocation.Bottom ? 20 : 0) + 5;
  }

  abstract get direction(): string;

  get anchor(): string {
    const location = this.specification.location;

    if (location === VertexInteractionPointLocation.Left ||
      location === VertexInteractionPointLocation.TopLeft ||
      location === VertexInteractionPointLocation.BottomLeft) {
      return 'end';
    }

    if (location === VertexInteractionPointLocation.Right ||
      location === VertexInteractionPointLocation.TopRight ||
      location === VertexInteractionPointLocation.BottomRight) {
      return 'start';
    }

    return 'middle';
  }

  ngOnDestroy(): void {
    this.graphService.unRegisterIOPoint(this, this.direction);
    super.ngOnDestroy();
  }

  ngOnInit(): void {
    this.graphService.registerIOPoint(this, this.direction);
    super.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./src/library/graph/vertex/interaction-point/workflow-graph-vertex-interaction-point.ts